import { ObserversBase } from "@share/program/observers/ObserversBase";
import { RealtimeMessageModel, SignalRMethod } from "@api/repositories/reatime-repository/types";
import { getMessageObjectIfSuccess } from "@api/helpers/realtimeMessageHandlers";

/**
 * Обновление лайков сессии в реальном времени
 * Общий метод для обновления лайков сессий и мероприятия
 */
export class AgendaLikesUpdatedObserver extends ObserversBase {
    method = SignalRMethod.objectLikesUpdated;

    handler(message: string) {
        const messageObject: RealtimeMessageModel | null = getMessageObjectIfSuccess(message);

        if (!messageObject) {
            return;
        }

        const { objectId, likes } = messageObject;

        if (objectId && (likes?.count || likes?.count === 0)) {
            this.programDataHelper.updateLikeRealTime(objectId, likes);
        }
    }
}
